module.exports = "<div class=\"promo-content\">\r\n    <p><strong>Please sign in for more information about this case, <br />including key passages and precedent analysis.</strong></p>\r\n    <p>{{> register-button}}</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/free-promo-content.html
// module id = 438
// module chunks = 1